const GENERAL = 'General Works';
const FURNISHINGS = 'Furnishings';
const ELECTRICAL_APPLIANCES = 'Electrical Appliances';
const KITCHEN_UTENSILS = 'Kitchen Utensils';
const LINENS = 'Linens';

const ITEM_OWNED_AIRCOND = 'Air-conditioner';
const ITEM_OWNED_ELECTRIC_STOVE = 'Electric Stove';
const ITEM_OWNED_KITCHEN_CABINET = 'Kitchen Cabinet';
const ITEM_OWNED_WATER_HEATER = 'Water Heater';

const sections = [GENERAL, FURNISHINGS, ELECTRICAL_APPLIANCES, KITCHEN_UTENSILS, LINENS];

/** DINING */
const DEFAULT_DINING_CHAIRS = 6;

/** BEDROOMS */
const DEFAULT_NO_OF_SIDE_TABLE = 2;
const DEFAULT_NO_OF_DUSTBIN = 6;

/** ELECTRICAL_APPLIANCES */
const DEFAULT_NO_OF_CEILING_FAN = 2;

/** LINENS */
const DEFAULT_NO_OF_FLAT_SHEET = 3;
const DEFAULT_NO_OF_DUVET_COVER_SET = 3;
const DEFAULT_NO_OF_PILLOW = 2;
const DEFAULT_NO_OF_PILLOW_COVER = 3;
const DEFAULT_NO_OF_BATH_TOWEL = 5;
const DEFAULT_NO_OF_BATH_MAT = 3;

const getItems = (
  noOfBedrooms = 1,
  noOfBathrooms = 1,
  itemsOwned = []
) => {
  noOfBedrooms = Number(noOfBedrooms);
  noOfBathrooms = Number(noOfBathrooms);
  return [
    {
      label: 'Lighting Fixtures',
      description: 'Sufficient lighting with LED surface downlights.',
      quantity: '1 LS',
      type: GENERAL,
      total: (7 + noOfBedrooms * 2 + noOfBathrooms) * 25
    },
    {
      label: 'Wiring Works',
      description: 'Covers electrical wiring for the whole unit.',
      quantity: '1 LS',
      type: GENERAL,
      total: (((7 + noOfBedrooms * 2 + noOfBathrooms) * 45 + 60 * DEFAULT_NO_OF_CEILING_FAN)) / 0.8
    },
    {
      label: 'Curtains & Blinds',
      description: 'Curtains & blinds, maximum height of 10 feet.',
      quantity: '1 LS',
      type: GENERAL,
      total: 1875
    },
    {
      label: 'Cleaning',
      description: 'Ensure on-site cleanliness and provides industrial cleanup upon completion.',
      quantity: '1 LS',
      type: GENERAL,
      total: 750
    },
    {
      label: 'Site Coordination',
      description: 'Inspects, monitors, and coordinates the renovation process.',
      quantity: '1 LS',
      type: GENERAL,
      total: 438
    },
    {
      label: 'Kitchen Cabinet',
      description: 'Laminated counter top c/w particle board carcase',
      quantity: '1 LS',
      type: GENERAL,
      isExcluded: itemsOwned.includes(ITEM_OWNED_KITCHEN_CABINET),
      total: 5000
    },
    {
      label: 'Living Room',
      subItems: [
        {
          label: 'Coffee Table',
          quantity: '1 Unit'
        },
        {
          label: '3 Seater Sofa & Bed',
          quantity: '1 Unit'
        },
        {
          label: 'TV Console',
          quantity: '1 Unit'
        },
        {
          label: 'Wall Decor Painting',
          quantity: '1 Unit'
        },
        {
          label: 'Ottoman',
          quantity: '1 Unit'
        }
      ],
      type: FURNISHINGS,
      total: 270 + 1213 + 530 + 138 + 174
    },
    {
      label: 'Dining Room',
      subItems: [
        {
          label: 'Dining Table',
          quantity: '1 Set'
        },
        {
          label: 'Dining Chairs',
          quantity: `${DEFAULT_DINING_CHAIRS} Set`
        }
      ],
      type: FURNISHINGS,
      total: 372 + 180 * DEFAULT_DINING_CHAIRS
    },
    {
      label: 'Bedrooms',
      subItems: [
        {
          label: 'Queen Mattress + Divan Set + Mattress Protector',
          quantity: `${noOfBedrooms} Set`
        },
        {
          label: '3 Door Wardrobe with Mirror',
          quantity: `${noOfBedrooms} Set`
        },
        {
          label: 'Side Table',
          quantity: `${noOfBedrooms * DEFAULT_NO_OF_SIDE_TABLE} Unit`
        },
        {
          label: 'Cloth Hanger | 5 PC',
          quantity: `${noOfBedrooms} Set`
        },
        {
          label: 'Wall Décor Painting',
          quantity: `${noOfBedrooms} Unit`
        }
      ],
      type: FURNISHINGS,
      total: noOfBedrooms * 1250 + noOfBedrooms * 588 + noOfBedrooms * DEFAULT_NO_OF_SIDE_TABLE * 169 + noOfBedrooms * 15 + noOfBedrooms * 138
    },
    {
      label: 'Bathrooms',
      subItems: [
        {
          label: 'Mirror 480mm x 600mm',
          quantity: `${noOfBathrooms} Unit`
        },
        {
          label: 'SS. Cloth Hanger',
          quantity: `${noOfBathrooms} Unit`
        },
        {
          label: 'Toilet Bowl Brush',
          quantity: `${noOfBathrooms} Unit`
        },
        {
          label: 'Dustbin',
          quantity: `${DEFAULT_NO_OF_DUSTBIN} Unit`
        },
        {
          label: 'Shower Basket',
          quantity: `${noOfBathrooms} Unit`
        }
      ],
      type: FURNISHINGS,
      total: noOfBathrooms * 62 + noOfBathrooms * 19 + noOfBathrooms * 5 + DEFAULT_NO_OF_DUSTBIN * 6 + noOfBathrooms * 38
    },
    {
      label: '45" Full HD LED TV',
      description: 'With USB (video, photo, music), HDMI x 2, MHL & Digital Tuner, Super Eco Mode',
      quantity: `1 Unit`,
      type: ELECTRICAL_APPLIANCES,
      total: 1812
    },
    {
      label: 'Antenna / TV Cable / TV Box',
      quantity: `1 Unit`,
      type: ELECTRICAL_APPLIANCES,
      total: 88
    },
    {
      label: 'Fridge',
      description: '240 litres',
      quantity: `1 Unit`,
      type: ELECTRICAL_APPLIANCES,
      total: 1125
    },
    {
      label: 'PENSONIC 2000W Hair Dryer',
      quantity: `1 Unit`,
      type: ELECTRICAL_APPLIANCES,
      total: 79
    },
    {
      label: 'Stainless Steel Jug Kettle',
      description: '1.8 litres',
      quantity: `1 Unit`,
      type: ELECTRICAL_APPLIANCES,
      total: 50
    },
    {
      label: 'Dry Iron',
      quantity: `1 Unit`,
      type: ELECTRICAL_APPLIANCES,
      total: 56
    },
    {
      label: 'Tabletop Ironing Board',
      quantity: `1 Unit`,
      type: ELECTRICAL_APPLIANCES,
      total: 35
    },
    {
      label: 'Ceiling Fan',
      quantity: `${DEFAULT_NO_OF_CEILING_FAN} Unit`,
      type: ELECTRICAL_APPLIANCES,
      total: DEFAULT_NO_OF_CEILING_FAN * 438
    },
    {
      label: 'Air-conditioner',
      quantity: `${noOfBedrooms} Unit`,
      type: ELECTRICAL_APPLIANCES,
      total: noOfBedrooms * 1500,
      isExcluded: itemsOwned.includes(ITEM_OWNED_AIRCOND)
    },
    {
      label: 'Water Heater',
      quantity: `${noOfBathrooms} Unit`,
      type: ELECTRICAL_APPLIANCES,
      total: noOfBathrooms * 875,
      isExcluded: itemsOwned.includes(ITEM_OWNED_WATER_HEATER)
    },
    {
      label: 'Multi Cooker',
      quantity: `1 Unit`,
      type: ELECTRICAL_APPLIANCES,
      total: 1250,
      isExcluded: itemsOwned.includes(ITEM_OWNED_ELECTRIC_STOVE)
    },
    {
      label: 'Electrical Hood',
      quantity: `1 Unit`,
      type: ELECTRICAL_APPLIANCES,
      total: 2013,
      isExcluded: itemsOwned.includes(ITEM_OWNED_ELECTRIC_STOVE)
    },
    {
      label: 'Dining Utensils - Spoon | 12 pc',
      quantity: `1 Unit`,
      type: KITCHEN_UTENSILS,
      total: 11
    },
    {
      label: 'Dining Utensils - Fork | 12 pc',
      quantity: `1 Unit`,
      type: KITCHEN_UTENSILS,
      total: 11
    },
    {
      label: 'Dining Utensils - Tea Spoon | 12 pc',
      quantity: `1 Unit`,
      type: KITCHEN_UTENSILS,
      total: 12
    },
    {
      label: 'Dining Utensils - Bowl | 6 pc',
      quantity: `1 Unit`,
      type: KITCHEN_UTENSILS,
      total: 53
    },
    {
      label: 'Dining Utensils - Plate | 6 pc',
      quantity: `1 Unit`,
      type: KITCHEN_UTENSILS,
      total: 53
    },
    {
      label: 'Dining Utensils - Drinking Glass | 6 pc',
      quantity: `1 Unit`,
      type: KITCHEN_UTENSILS,
      total: 53
    },
    {
      label: 'Dining Utensils - Coffee Cup + Saucer | 6 pc',
      quantity: `1 Unit`,
      type: KITCHEN_UTENSILS,
      total: 53
    },
    {
      label: 'Cooking Pan',
      quantity: `1 Unit`,
      type: KITCHEN_UTENSILS,
      total: 15
    },
    {
      label: 'Cooking Pot',
      quantity: `1 Unit`,
      type: KITCHEN_UTENSILS,
      total: 30
    },
    {
      label: 'QS Flat Sheet',
      quantity: `${noOfBedrooms * DEFAULT_NO_OF_FLAT_SHEET} Unit`,
      type: LINENS,
      total: noOfBedrooms * DEFAULT_NO_OF_FLAT_SHEET * 39
    },
    {
      label: 'QS Duvet Inner',
      quantity: `${noOfBedrooms} Unit`,
      type: LINENS,
      total: noOfBedrooms * 63
    },
    {
      label: 'QS Duvet Cover Set',
      quantity: `${noOfBedrooms * DEFAULT_NO_OF_DUVET_COVER_SET} Unit`,
      type: LINENS,
      total: noOfBedrooms * DEFAULT_NO_OF_DUVET_COVER_SET * 61
    },
    {
      label: 'Pillow',
      quantity: `${noOfBedrooms * DEFAULT_NO_OF_PILLOW} Unit`,
      type: LINENS,
      total: noOfBedrooms * DEFAULT_NO_OF_PILLOW * 21
    },
    {
      label: 'Pillow Cover',
      quantity: `${noOfBedrooms * DEFAULT_NO_OF_PILLOW * DEFAULT_NO_OF_PILLOW_COVER} Unit`,
      type: LINENS,
      total: noOfBedrooms * DEFAULT_NO_OF_PILLOW * DEFAULT_NO_OF_PILLOW_COVER * 7
    },
    {
      label: 'Bath Towel | White',
      quantity: `${DEFAULT_NO_OF_BATH_TOWEL} Unit`,
      type: LINENS,
      total: DEFAULT_NO_OF_BATH_TOWEL * 17
    },
    {
      label: 'Bath Mat',
      quantity: `${noOfBathrooms * DEFAULT_NO_OF_BATH_MAT} Unit`,
      type: LINENS,
      total: noOfBathrooms * DEFAULT_NO_OF_BATH_MAT * 14
    }
  ];
};

export { 
  getItems,
  sections,
  ITEM_OWNED_AIRCOND,
  ITEM_OWNED_ELECTRIC_STOVE,
  ITEM_OWNED_KITCHEN_CABINET,
  ITEM_OWNED_WATER_HEATER,
};
